import { formatDistanceToNow } from 'date-fns';
import { dateLocales } from '../i18n';

export function formatDistanceToNowLocalized(date: Date | number, locale: string) {
  return formatDistanceToNow(date, {
    addSuffix: true,
    locale: dateLocales[locale as keyof typeof dateLocales],
  });
};
